'use strict';

angular.module('shiftTraderApp')
  .directive('saMediaViewer', ['$http', function($http) {
    return {
      restrict: 'A',
      scope: {
        media: '='
      },
      templateUrl: 'views/directives/saMediaViewer.html',
      link: function(scope, elem, attrs, controller) {
          scope.state = {
            source: null,
            style: {}
          };

          // Determine the source for the image to be used.
          var m = scope.media;
          if (m.service_type == 'filestack') {
            var searchField = (m.file_type) ? m.file_type: m.data.mimetype;

            var isImage = searchField.search('image') !== -1;
            if (isImage) {
              scope.state.style = {
                'width': '100%',
                'height': 'auto'
              };
            } else {
              scope.state.style = {
                'width': 'auto',
                'height': '100%'
              };
            }

            if (isImage) {
              scope.state.source = 'https://cdn.filestackcontent.com/' + m.external_id;
            } else if (searchField.search('pdf') !== -1) {
              scope.state.source = 'https://d327l0dy67qzb.cloudfront.net/static_assets/file_types/FileType_PDF.png';
            } else if (searchField.search('word') !== -1) {
              scope.state.source = 'https://d327l0dy67qzb.cloudfront.net/static_assets/file_types/FileType_Document.png';
            } else if (searchField.search('powerpoint') !== -1) {
              scope.state.source = 'https://d327l0dy67qzb.cloudfront.net/static_assets/file_types/FileType_Presentation.png';
            } else if (searchField.search('excel') !== -1) {
              scope.state.source = 'https://d327l0dy67qzb.cloudfront.net/static_assets/file_types/FileType_Spreadsheet.png';
            }

            $(elem).find('img').css(scope.state.style);
          } else if (m.service_type == 'youtube') {
            var tail = '/maxresdefault.jpg';
            if (attrs.hasOwnProperty('thumbnail')) {
              tail = '/mqdefault.jpg';
            }
            scope.state.source = 'https://img.youtube.com/vi/' + m.external_id + tail;
          } else if (m.service_type == 'vimeo') {
            $http.get(
              'https://vimeo.com/api/oembed.json?url=' + encodeURIComponent('https://www.vimeo.com/' + m.external_id)
            ).then(function(res) {
              console.log("Success on Thumb", res, res.data.thumbnail_url);
              scope.state.source = res.data.thumbnail_url;
            }, function(err, res) {
              console.log("Error on Thumbnail", err);
            });
          } else if (m.service_type == 'wistia') {

          } else {
            ; // Nothing
          }

      }
    }
  }]);
